import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {BioentityAliasInfo} from 'constants/RegistryConstants';
import * as BioentityActions from 'inventory/BioentityActions';
import getTestProps from 'test/lib/cypress/getTestProps';

import AliasField from './AliasField';

interface RegistryIdListProps {
  fileId: string;
  isRegistryWritable: boolean;
  registryIds: Array<BioentityAliasInfo>;
}

export default function RegistryIdList(props: RegistryIdListProps): JSX.Element {
  const handleUpdate = (originalAlias: string, newAlias: string): void => {
    BioentityActions.updateAliasWithDataMods(props.fileId, originalAlias, newAlias, true);
  };

  return (
    <div {...getTestProps({component: 'RegistryIdList', element: 'root'})}>
      <div className="metadata-header">{pluralize(props.registryIds.length, 'Registry ID')}</div>
      {props.registryIds.map((registryId) => (
        <AliasField
          className="metadata-field--registryId"
          complete={(newAlias) => {
            handleUpdate(registryId.alias, newAlias);
          }}
          key={registryId.alias}
          initialAlias={registryId.alias}
          subtitle={registryId.registryCollectionOwner?.name}
          isWritable={props.isRegistryWritable}
        />
      ))}
    </div>
  );
}
